// JsFromRoutes CacheKey 8cee1b8a32b24ef791c1aee3920cc5e4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/subscription'),
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/subscription'),
}
